/* eslint-disable no-param-reassign,no-self-assign,no-underscore-dangle,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerEdge', [
    '$rootScope',
    'DesignerBase',

    function ($rootScope, DesignerBase) {
      function DesignerEdge(data, _package) {
        this._data = data;
        this.package = _package;

        this.id = null;
        this.label = null;
        this.order = 0;
        this.source_index = 0;
        this.source = null;
        this.target = null;
        this.sourceComponent = null;
        this.targetComponent = null;
        this.event = null; // "failure|success|completion"

        this.initiated = false;

        const position = {
          x: 0,
          y: 0,
        };

        this.sourcePosition = position;
        this.targetPosition = position;
        this.sourceCurvePosition = position;
        this.targetCurvePosition = position;
        this.togglePosition = position;

        this.element = null;
        this.$toggle = null;
        this.$path = null;
        this.$pathDashed = null;
        this.$mapLine = null;

        this.setData(data);
      }

      DesignerEdge.prototype = new DesignerBase();

      DesignerEdge.prototype.setElement = function (element) {
        this.element = element;
        this.$toggle = element.find('.designer-edge-toggle');
        this.$connector = element.find('.designer-edge-connector');
        this.$path = element.find('.designer-edge-path');
        this.$pathDashed = element.find('.designer-edge-path-dashed');

        this.initiated = true;
        this.bind();
        this.setPosition();
      };

      DesignerEdge.prototype.destroy = function () {
        if (this.componentSourcePositionChange) this.componentSourcePositionChange();
        if (this.componentSourceOffsetChange) this.componentSourceOffsetChange();
        if (this.componentTargetPositionChange) this.componentTargetPositionChange();
        if (this.componentTargetOffsetChange) this.componentTargetOffsetChange();

        this.initiated = false;
      };

      DesignerEdge.prototype.setData = function (data) {
        this.id = data.id || `edge-${this.uid()}`;
        this.label = data.label || data.id;
        this.order = data.order || 0;
        this.source_index = data.source_index || 0;
        this.source = data.source;
        this.target = data.target;

        this.event = data.event || (this.package.flow_type === 'workflow' ? 'success' : null);

        this.targetEdge = data.targetEdge;
        this.targetComponent = data.targetComponent;

        this.sourceComponent = this.package.getComponentById(this.source);

        if (this.sourceComponent) {
          this.sourcePosition = _fixSource(this.sourceComponent.getPosition());
          this.sourceComponent.addOutput(this);

          if (!this.targetEdge) {
            this.targetComponent = this.package.getComponentById(this.target);
            if (this.targetComponent) {
              this.targetPosition = _fixTarget(this.targetComponent.getPosition());
              this.targetComponent.addInput(this);
            }
          }
        }
      };

      DesignerEdge.prototype.getData = function () {
        const edge = {
          id: this.id,
          label: this.label,
          order: this.order,
          source_index: this.source_index,
          source: this.source,
          target: this.target,
        };

        if (this.package.flow_type === 'workflow') {
          edge.event = this.event;
        }

        return edge;
      };

      var _fixSource = function (position) {
        position.x += 28 * 2.5;
        position.y += 28 * 3 + 7;
        return position;
      };

      var _fixTarget = function (position) {
        position.x += 28 * 2.5;
        position.y += -7;
        return position;
      };

      DesignerEdge.prototype.bind = function () {
        const _this = this;

        this.$toggle.on('click', function (e) {
          const context = {
            top: _this.togglePosition.y,
            left: _this.togglePosition.x,
            items: [
              {
                text: 'Disconnect',
                cssClass: 'remove',
                action(argument) {
                  _this.package.removeEdge(_this);
                  $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
                },
              },
            ],
          };

          if (_this.package.flow_type === 'workflow') {
            context.items = [
              {
                text: 'On failure',
                cssClass: 'failure',
                action() {
                  _this.element[0].classList.add('failure');
                  _this.element[0].classList.remove('completion');
                  _this.element[0].classList.remove('success');
                  _this.event = 'failure';
                  _this.package.designer.history.save('Edge condition changed to failure');
                  $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
                },
              },
              {
                text: 'On completion',
                cssClass: 'completion',
                action() {
                  _this.element[0].classList.add('completion');
                  _this.element[0].classList.remove('failure');
                  _this.element[0].classList.remove('success');
                  _this.event = 'completion';
                  _this.package.designer.history.save('Edge condition changed to completion');
                  $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
                },
              },
              {
                text: 'On success',
                cssClass: 'success',
                action() {
                  _this.element[0].classList.add('success');
                  _this.element[0].classList.remove('completion');
                  _this.element[0].classList.remove('failure');
                  _this.event = 'success';
                  _this.package.designer.history.save('Edge condition changed to success');
                  $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
                },
              },
              {
                text: '',
                cssClass: 'divider',
                action(argument) {
                  _this.package.removeEdge(_this);
                  $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
                },
              },
              {
                text: 'Disconnect',
                cssClass: 'remove',
                action(argument) {
                  _this.package.removeEdge(_this);
                  $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_HIDE);
                },
              },
            ];
          }

          $rootScope.$broadcast(DESIGNER_EVENTS.CONTEXT_MENU_SHOW, context);
        });

        if (this.targetEdge) {
          this.element[0].classList.add('connector');

          this.componentTargetPositionChange = $rootScope.$on(
            DESIGNER_EVENTS.COMPONENT_POSITION_CHANGE + this.targetComponent.id,
            function () {
              _this.targetPosition = _this.targetComponent.getPosition();
              _this.setPosition();
            },
          );
        }

        if (this.event) {
          this.element[0].classList.add(this.event);
        }
      };

      const _getPathData = function (edge) {
        return `M${edge.sourcePosition.x},${edge.sourcePosition.y} C${edge.sourceCurvePosition.x},${edge.sourceCurvePosition.y},${edge.targetCurvePosition.x},${edge.targetCurvePosition.y},${edge.targetPosition.x},${edge.targetPosition.y}`;
      };

      const _setCurves = function (edge) {
        let toggleX;
        let toggleY;

        const sourceX = edge.sourcePosition.x;
        const sourceY = edge.sourcePosition.y + (edge.targetPosition.y - edge.sourcePosition.y) / 2;

        const targetX = edge.targetPosition.x;
        const targetY = edge.targetPosition.y - (edge.targetPosition.y - edge.sourcePosition.y) / 2;

        toggleX = edge.sourcePosition.x + (edge.targetPosition.x - edge.sourcePosition.x) / 2;
        toggleY = edge.sourcePosition.y + (edge.targetPosition.y - edge.sourcePosition.y) / 2;

        toggleX -= 11;
        toggleY -= 11;

        edge.sourceCurvePosition = {
          x: sourceX,
          y: sourceY,
        };

        edge.targetCurvePosition = {
          x: targetX,
          y: targetY,
        };

        edge.togglePosition = {
          x: toggleX,
          y: toggleY,
        };
      };

      DesignerEdge.prototype.setPosition = function (sourceOffset, targetOffset) {
        if (!this.initiated) return;

        if (this.targetPosition.x === 0) this.targetPosition.x = this.sourcePosition.x;

        if (this.targetPosition.y === 0) this.targetPosition.y = this.sourcePosition.y;

        _setCurves(this, sourceOffset, targetOffset);

        const toData = _getPathData(this);

        this.$path.attr('d', toData);
        this.$pathDashed.attr('d', toData);

        this.$toggle.attr('transform', `translate(${this.togglePosition.x},${this.togglePosition.y})`);
        this.$connector.attr(
          'style',
          `transform: translate(${this.targetPosition.x - 2}px,${this.targetPosition.y - 1}px)`,
        );
      };

      return DesignerEdge;
    },
  ]);
})(window.angular);
